<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 tag">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header border-bottom">
            <div class="tag d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Közműhálózat</h5>
              </div>
              <div class="col-6 text-end">
                <material-button
                    class="float-right btn btm-sm"
                    @click="this.$router.push({ name: 'Add Utility' })"
                >
                  <i class="fas fa-tag me-2"></i>
                  Közmű Hozzáadása
                </material-button>
              </div>
            </div>
          </div>

          <!-- Card body -->
          <div class="px-0 pb-0 card-body">

            <div class="table-responsive p-4">
              <!-- Table -->
              <DataTable id="dataTable" :data="data" :columns="columns" :options="dataTableOptions" ref="table"
                         class="table table-flush dataTable-table" width="100%">
                <template #action="props">
                  <td
                      class="dt-control"
                      :text="`Col 1: ${props.cellData}`"
                      @click="rowClick"
                  ></td>
                </template>
              </DataTable>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import eventTable from "@/mixins/eventTable.js";
import store from "@/store";
import _ from "lodash";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import BasePagination from "@/components/BasePagination.vue";
import {pagination} from "../../../consts";

DataTable.use(DataTablesCore);

var sortDirection = "created_at";

const getUtilitiesList = _.debounce(async function (params) {
  await store.dispatch("unetworks/getUnetworks");
}, 300);

export default {
  name: "UtilityList",
  components: {
    MaterialButton,
    MaterialInput,
    BasePagination,
    DataTable
  },
  mixins: [eventTable],
  setup() {
    const data = ref([]);
    const table = ref();
    const columns = [
      {title: 'Ingatlan'},
      {title: 'Hálózati szolgáltató'},
      {title: 'POD'},
      {title: 'Akció'},
    ];

    const dataTableOptions = ref(pagination);
    return {
      columns,
      dataTableOptions,
      data,
      table,
    }
  },
  data() {
    return {
      search: "",
      dataUtilities: [],
      pagination: {},
      dataTable: null,
      keys: null,
    };
  },
  computed: {
    UtilitiesList() {
      return this.$store.getters["unetworks/getUnetworksData"];
    },
    metaPage() {
      return this.$store.getters["unetworks/getUnetworksMeta"];
    },
  },
  watch: {
    UtilitiesList: {
      handler: "reactiveTable",
      immediate: false,
      deep: true,
    },
  },
  async mounted() {
    await getUtilitiesList({
      sort: sortDirection,
      query: "",
      //nr: getCurrentPage,
      //perpage: this.dataTable.options.perPage,
    });
  },
  beforeUnmount() {
    sortDirection = "created_at";
  },
  methods: {
    async getDataFromPage(page) {
      await getUtilitiesList({
        sort: sortDirection,
        query: this.search,
        nr: page,
        perpage: this.dataTable.options.perPage,
      });
    },

    async reactiveTable() {
      this.dataUtilities = [];
      if (this.UtilitiesList.length > 0) {
        this.UtilitiesList.forEach((network) => {
          this.dataUtilities.push([
            network.name,
            network.network_provider_name,
            network.pod,

            `<div class="text-end">${
                this.actionEditButton(network.id, "Főmérő módosítása") +
                this.actionDeleteButton(network.id, "Főmérő törlése")
            }</div>`,
          ]);
        });

        this.data = this.dataUtilities;
        this.removeEvent();
        await this.$nextTick();
        this.eventToCall({
          myUserId: null,
          redirectPath: "Edit Utility",
          deletePath: "unetworks/deleteUnetwork",
          getPath: "unetworks/getUnetworks",
          textDelete: "Közműhálózat sikeresen törölve!",
          textDefaultData: "unetworks",
        });
      } else {
        this.dataTable.setMessage("Nincs a keresési feltételnek megfelelő találat.");
      }
    },
  },
};
</script>

<style scoped lang="css">
@import 'datatables.net-bs5';
</style>
